export function showSpaOverlay() {
  const header = document.getElementsByTagName("header")[0];
  if (header) {
    header.style.zIndex = "2000";
    header.style.position = "relative";
  }

  const searchSpa = document.getElementsByClassName("search-spa")[0] as
    | HTMLElement
    | undefined;
  if (searchSpa) {
    searchSpa.style.zIndex = "1033";
    searchSpa.style.position = "relative";
  }

  const overlayDiv = document.createElement("div");
  overlayDiv.id = "spa-overlay";
  overlayDiv.className = "spa-overlay";
  document.body.appendChild(overlayDiv);
}

export function hideSpaOverlay() {
  const header = document.getElementsByTagName("header")[0];
  if (header) {
    header.style.zIndex = "";
  }

  const searchSpa = document.getElementsByClassName("search-spa")[0] as
    | HTMLElement
    | undefined;
  if (searchSpa) {
    searchSpa.style.zIndex = "";
  }

  const overlayDiv = document.getElementById("spa-overlay");
  if (overlayDiv) {
    document.body.removeChild(overlayDiv);
  }
}
